import CalculatorAth from './CalculatorAth';
export default CalculatorAth;